<template>
    <div class="page_error">
        ページの処理中にエラーが発生しました。<br>
        お手数ですが、もう一度お試しください。
    </div>
</template>

<script>
    export default {
        name: "Error"
    }
</script>

<style scoped lang="scss">
    .page_error{
        min-height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 2px 4px #d1d1d1 inset;
    }
</style>
